const RequestFaq = async (input, filtermessages, userId, mode,loginInfo) => {
    console.log('handleFaqQuestion')
    console.log('handleFaqQuestion_loginInfo',loginInfo)

    const filter = loginInfo.faqapi.faq.filter
    const query = {
        search: input,
        top: 6,
        filter: filter,
        select: "category,title,content,answer,site_name,URL,site_icon,model,update_at,tag",
        searchMode: "all",
        vectorQueries: [
          {
            kind: "text",
            text: input,
            k: 6,
            fields: "embedding"
          }
        ]
    };
    const header = {
        'Content-Type': 'application/json',
        'api-key': "XXXXXX",
    };

    const requestBody = {
        api:process.env.REACT_APP_FAQ_URL,
        header:header,
        query: query,
        filter:filter,
        userId: userId,
        mode:mode,
    };
    try {

        const response = await fetch(`${process.env.REACT_APP_CROSPRO_URL}?code=${process.env.REACT_APP_CROSPRO_KEY}`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(requestBody),
        });
        const data = await response.json();
        console.log('API_応答データ:', data);
        // APIのレスポンスを整形
        let message = ""; 
        data.forEach((item, index) => {
            console.log('API_データ1:', index);
            if (index === 0) { 
                // 最初の要素は特別なフォーマット
                message = `<p><a href="${item.URL}">${item.title}</a></p>${item.content}<p style="font-size: 20px; font-weight: bold;">【関連するFAQ】<ul>`;
            } else { 
                // それ以降の要素をリストとして追加
                message += `<li><a href="${item.URL}">${item.title}</a></li>`; 
            }
            // 配列の最後の要素だったら、リストを閉じる
            if (index === data.length - 1) {
                message += `</ul></p>`;
            }
        });

        return message
        //onApiResponse({'data':botMessages.join('\n'),'type':'html'});
    } catch (error) {
        return `申し訳ありません。<br>問合せエラーが発生しました。`
        //onApiResponse({'data':'<p>Error: Failed to get response.</p>','type':'html'});
    }

};

// 🔹 他のファイルで使えるようにエクスポート
export default RequestFaq;